import React, { useEffect } from "react";
import cn from "classnames";
import { MapHomeIcon } from "@/icons";
import { MapViewCard } from "./card";
import Loading from "@/components/dc-loading";
import Filters from "../Filters";
import scaleSvg from "@/images/scale.svg";
import scaleOutSvg from "@/images/reducing-screen-flip.svg";
import plusSvg from "@/images/plus2.svg";
import minusSvg from "@/images/minus.svg";

/**
 * 桌面端地图工具栏组件
 * 包含空状态提示、回到首页按钮和餐厅列表
 */
const MapViewDesktopTool = ({
  mapRef,
  pendingPopupLatLngRef,
  showEmpty,
  handleCleanFilter,
  showHomeIcon,
  handleMapHomeClick,
  mapSelectedRestaurants,
  avgPriceLabel,
  loading,
  isFullscreen,
  handleToggleFullscreen,
  handleZoomIn,
  handleZoomOut,
}) => {
  return (
    <>
      {/* 空状态提示 */}
      {showEmpty.visible && isFullscreen && (
        <div
          className={cn("map-view-empty map-view-empty-desktop", {
            "map-view-empty-by-map": true,
          })}
          onClick={handleCleanFilter}
        >
          {showEmpty.text}
        </div>
      )}
      {/* 加载状态 */}
      {loading && (
        <div className="map-view-loading">
          <div className="map-view-loading-mask"></div>
          <div className="map-view-loading-spinner">
            <Loading />
          </div>
        </div>
      )}
      {/* 桌面端筛选器（全屏模式） */}
      {isFullscreen && (
        <div className="map-view-desktop-filters">
          <Filters />
        </div>
      )}

      {/* 桌面端工具栏 */}
      <div className="map-view-desktop-tools">
        <div className="desktop-tools-item" onClick={handleToggleFullscreen}>
          <img src={isFullscreen ? scaleOutSvg : scaleSvg} alt={isFullscreen ? "Scale Out" : "Scale In"} />
        </div>
        {showHomeIcon && (
          <div className="desktop-tools-item" onClick={handleMapHomeClick}>
            <MapHomeIcon />
          </div>
        )}
        <div className="desktop-tools-item-group">
          <div className="desktop-tools-item" onClick={handleZoomIn}>
            <img src={plusSvg} alt="Zoom In" />
          </div>
          <div className="desktop-tools-item" onClick={handleZoomOut}>
            <img src={minusSvg} alt="Zoom Out" />
          </div>
        </div>
      </div>
      {/* 餐厅卡片 */}
      <MapViewCardList
        mapRef={mapRef}
        pendingPopupLatLngRef={pendingPopupLatLngRef}
        restaurants={mapSelectedRestaurants}
        avgPriceLabel={avgPriceLabel}
      />
    </>
  );
};

function MapViewCardList({
  mapRef,
  pendingPopupLatLngRef,
  restaurants,
  avgPriceLabel,
}) {
  const listRef = React.useRef(null);

  useEffect(() => {
    if (!mapRef?.current || !pendingPopupLatLngRef.current) return;
    setTimeout(() => {
      mapRef.current?.setPopup(
        pendingPopupLatLngRef.current,
        listRef.current.cloneNode(true),
      );
      pendingPopupLatLngRef.current = null;
    }, 50);
    
  }, [restaurants, mapRef, pendingPopupLatLngRef]);

  return (
    <div
      id="map-view-desktop-card-list"
      ref={listRef}
      className={cn("map-view-desktop-card-list", {
        "one-card": restaurants.length === 1,
        "more-card": restaurants.length > 1,
      })}
    >
      <div className="map-view-desktop-card-list-inner">
        {restaurants.map((item) => (
          <MapViewCard
            restaurant={item}
            avgPriceLabel={avgPriceLabel}
            key={item.id}
          />
        ))}
      </div>
    </div>
  );
}

export default MapViewDesktopTool;
